import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { formatPhoneNumber, formatServiceAddress } from '@wayste/client-utils';
import { UserIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../formWrapper/SourSearchWrapper';
import { ErrorBoundary } from './helper/ErrorBoundary';
import { ResultWrapper } from './helper/resultWrapper';
export const LeadResult = ({ lead }) => {
    const { firstName, lastName, serviceLocation, phoneNumber, email } = lead;
    const { onNavigate, onResetValues } = useContext(CustomFormContext);
    // useEffect(() => {
    //   console.log('PAYLOAD LEAD', lead);
    // }, []);
    const handleRedirect = () => {
        onNavigate(lead, lead.id, 'lead');
        onResetValues('search');
    };
    const ensureAddress = (address) => {
        if (Object.values(address).every((field) => field !== undefined)) {
            return address;
        }
        return address;
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(UserIcon, { className: "size-4" }), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: firstName }), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: lastName }), serviceLocation?.address ? (_jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: formatServiceAddress(ensureAddress(serviceLocation?.address)) })) : (_jsx(_Fragment, {})), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: email }), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: formatPhoneNumber(phoneNumber) })] }) }));
};
//# sourceMappingURL=LeadResult.js.map